"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Expand = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Expand_1 = require("./Expand");
const Expand = (props) => {
    return (0, jsx_runtime_1.jsx)(Expand_1.Expand, Object.assign({}, props));
};
exports.Expand = Expand;
